export default "__VITE_ASSET__ICCxXuMm__"